export { MedicalCard } from './ui';
